// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__9lag7","selects":"Documents_selects__dyMJx"};